<template>
	<div class="autoReplyConfig">
		<!-- 插件样式 -->
		<!-- <el-row class="config" type="flex">
			<el-col :span="24" class="set">
				<client-module moduletitle="样式设置">
					<plugStyle
						:position="position"
						:color="color"
						:state="pattern"
						:DialogDisplay="DialogDisplay"
						:login="login"
						:pointLabel="pointLabel"
						:pointIcon="pointIcon"
						:thumb="thumb"
						:name="name"
						@changebasic="saveBasic"
					></plugStyle>
				</client-module>
			</el-col>
		</el-row> -->

		<!-- 开始对话 -->
		<el-row class="config" type="flex">
			<el-col :span="24" class="set">
				<client-module moduletitle="开始对话">
					<span slot="customHint" class="hint"
						>开始对话后主动向客户发送第一条消息，在对话中显示</span
					>
					<conversation
						:dialogue="dialogue"
						:emailOpenFlag="emailOpenFlag"
						:emailName="emailName"
						:staffServiceOpenFlag="staffServiceOpenFlag"
						:staffServiceName="staffServiceName"
						:staffServiceContent="staffServiceContent"
						:visitWebsiteOpenFlag="visitWebsiteOpenFlag"
						:visitWebsiteName="visitWebsiteName"
						:visitWebsiteContent="visitWebsiteContent"
						:email="email"
						:emailContent="emailContent"
						:thumb="thumb"
						:name="name"
						@changeconversation="Saveconversation"
					></conversation>
				</client-module>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import plugStyle from '@/backend/pages/socialMedia/plugStyle.vue';
import fixmenu from '@/backend/pages/socialMedia/fixmenu.vue';
import headerPanel from '@/components/client/clientModule/headerPanel';
import conversation from '@/backend/pages/socialMedia/conversation.vue';
import chat from '@/backend/services/account/chat.js';
import clientModule from '@/components/client/clientModule/clientModule';

export default {
	name: 'autoReplyConfig',
	props: ['configInfo'],
	components: {
		fixmenu,
		headerPanel,
		conversation,
		clientModule,
		plugStyle,
	},
	data() {
		return {
			configInfoCopy: {},
			name: '',
			thumb: '',
			position: '',
			color: '',
			pattern: '',
			page: '',
			login: '',
			visitor: '',
			dialogue: '',
			DialogDisplay: '',
			pointIcon: '',
			pointLabel: '',
			menuList: [],
			emailOpenFlag: '',
			emailName: '',
			staffServiceOpenFlag: '',
			staffServiceName: '',
			staffServiceContent: '',
			visitWebsiteOpenFlag: '',
			visitWebsiteName: '',
			visitWebsiteContent: '',
			email: '',
			emailContent: '',
			bottomFlag: '',
			fbConfigProblemDTOList: [],
			id: '',
		};
	},
	computed: {
		queryParam() {
			return this.$route.query;
		},
		getserviceId: function () {
			let serviceId = this.$route.query.serviceSiteId;
			return serviceId;
		},

		getId: function () {
			let Id = this.$route.query.id;
			return Id;
		},

		getcustomerId: function () {
			let customerId = this.$route.query.customerId;
			return customerId;
		},

		gettpageId: function () {
			let tpageId = this.$route.query.tpageId;
			return tpageId;
		},
	},
	watch: {
		configInfo: {
			handler(val) {
				this.configInfoCopy = val;
				this.getdatacollect();
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		//获取即时聊天配置信息
		async getdatacollect() {
			let { configInfoCopy } = this;

			const {
				showPosition, //显示位置（1、左上 2、右下）
				colour, //颜色
				dialogueGreetings, //对话欢迎语
				emailOpenFlag, //客户请求邮箱开关（0、否  1、是）
				emailName, //客户请求邮箱按钮名称
				staffServiceOpenFlag, //客户请求人工客服开关（0、否 1、是）
				staffServiceContent, //客户请求人工服务自动回复内容
				staffServiceName, //客户请求人工服务按钮名称
				visitWebsiteOpenFlag, //访问网址开关
				visitWebsiteName, //访问网址按钮名称
				visitWebsiteContent, //访问网址自动回复内容
				requestEmail, //是否发送请求邮箱
				emailContent, //请求邮箱内容
				loginGreetings, //登录状态问候语
				pageGreetings, //公共主页问候语
				visitorGreetings, //访客状态问候语
				visitorFlag, //是否启用访客模式（0、否   1、是）
				pageThumb, //主页头像
				pageName, //主页名称
				greetingDialogDisplay,
				entryPointLabel,
				entryPointIcon,
				bottomFlag, //是否开启底部菜单（0、否  1、是）
				fbConfigProblemDTOList, //常见问题
				id, //主键ID
			} = configInfoCopy;
			this.name = pageName;
			this.thumb = pageThumb;
			showPosition ? (this.position = showPosition) : (this.position = 1);
			colour ? (this.color = colour) : (this.color = '#3DA1FF');
			visitorFlag !== null ? (this.pattern = visitorFlag) : (this.pattern = 1);
			pageGreetings ? (this.page = pageGreetings) : (this.page = 'Hi,How can we help you?');
			loginGreetings ? (this.login = loginGreetings) : (this.login = 'Hi,How can we help you?');
			visitorGreetings
				? (this.visitor = visitorGreetings)
				: (this.visitor = 'Hi,How can we help you?');
			dialogueGreetings
				? (this.dialogue = dialogueGreetings)
				: (this.dialogue = 'Hi How can we help you?');
			requestEmail !== null ? (this.email = requestEmail) : (this.email = 1);
			emailContent !== null
				? (this.emailContent = emailContent)
				: (this.emailContent = 'send us your email or phone number:');
			emailOpenFlag !== null ? (this.emailOpenFlag = emailOpenFlag) : (this.emailOpenFlag = 1);
			emailName !== null ? (this.emailName = emailName) : (this.emailName = 'contact me');
			staffServiceOpenFlag !== null
				? (this.staffServiceOpenFlag = staffServiceOpenFlag)
				: (this.staffServiceOpenFlag = 0);
			staffServiceName !== null
				? (this.staffServiceName = staffServiceName)
				: (this.staffServiceName = '');
			staffServiceContent !== null
				? (this.staffServiceContent = staffServiceContent)
				: (this.staffServiceContent = '');
			visitWebsiteOpenFlag !== null
				? (this.visitWebsiteOpenFlag = visitWebsiteOpenFlag)
				: (this.visitWebsiteOpenFlag = 1);
			visitWebsiteName !== null
				? (this.visitWebsiteName = visitWebsiteName)
				: (this.visitWebsiteName = 'Visit our Site');
			visitWebsiteContent !== null
				? (this.visitWebsiteContent = visitWebsiteContent)
				: (this.visitWebsiteContent = `https://${this.queryParam.URl}`);
			bottomFlag !== null ? (this.bottomFlag = bottomFlag) : this.bottomFlag == 0;
			greetingDialogDisplay !== null
				? (this.DialogDisplay = greetingDialogDisplay)
				: (this.DialogDisplay = 0);
			entryPointIcon !== null ? (this.pointIcon = entryPointIcon) : (this.pointIcon = 0);
			entryPointLabel !== null ? (this.pointLabel = entryPointLabel) : (this.pointLabel = 0);
			if (fbConfigProblemDTOList !== null) {
				this.fbConfigProblemDTOList = fbConfigProblemDTOList;
			} else {
				this.fbConfigProblemDTOList = [
					{ problem: '我是问题', reply: '回答' },
					{ problem: '我是问题', reply: '回答' },
				];
			}
			this.id = id;
			if (
				showPosition == null &&
				colour == null &&
				visitorFlag == null &&
				pageGreetings == null &&
				loginGreetings == null &&
				visitorGreetings == null &&
				dialogueGreetings == null &&
				emailOpenFlag == null &&
				emailName == null &&
				requestEmail == null &&
				emailContent == null &&
				staffServiceOpenFlag == null &&
				staffServiceName == null &&
				staffServiceContent == null &&
				visitWebsiteOpenFlag == null &&
				visitWebsiteName == null &&
				visitWebsiteContent == null &&
				greetingDialogDisplay == null &&
				entryPointIcon == null &&
				entryPointLabel == null &&
				fbConfigProblemDTOList == null
			) {
				this.Savedefault();
			}
		},
		// 默认配置的保存修改
		async Savedefault() {
			let weburl = `https://${this.queryParam.URl}`;
			await chat.getfabasic({
				serviceSiteId: this.getserviceId,
				customerId: this.getcustomerId,
				colour: '#3DA1FF',
				showPosition: 2,
				visitorFlag: 1,
				pageGreetings: 'Hi,How can we help you?',
				loginGreetings: 'Hi,How can we help you?',
				visitorGreetings: 'Hi,How can we help you?',
				dialogueGreetings: 'Hi,How can we help you?',
				emailOpenFlag: 1,
				emailName: 'contact me',
				staffServiceOpenFlag: 0,
				staffServiceName: '',
				staffServiceContent: '',
				visitWebsiteOpenFlag: 1,
				visitWebsiteName: 'Visit our Site',
				visitWebsiteContent: weburl,
				requestEmail: 1,
				emailContent: 'send us your email or phone number:',
				bottomFlag: 0,
				greetingDialogDisplay: 0,
				entryPointIcon: 1,
				entryPointLabel: 2,
				fbConfigProblemDTOList: [
					{
						problem: '我是问题',
						reply: '回答',
					},
					{
						problem: '我是问题',
						reply: '回答',
					},
				],
			});
			this.emitData();
		},

		//插件样式保存修改
		async saveBasic({ weizhi, zhuangtai, yanse, mode, greet, pointLabel, picIcon }, reset) {
			let customid = this.getcustomerId;
			this.position = weizhi;
			this.pattern = zhuangtai;
			this.color = yanse;
			this.DialogDisplay = mode;
			this.login = greet;
			this.pointLabel = pointLabel;
			this.pointIcon = picIcon;
			try {
				let res = await chat.getfabasic({
					serviceSiteId: this.getserviceId,
					showPosition: weizhi,
					visitorFlag: zhuangtai,
					greetingDialogDisplay: mode,
					colour: yanse,
					pageGreetings: greet,
					loginGreetings: greet,
					visitorGreetings: greet,
					entryPointLabel: pointLabel ? pointLabel : 0,
					entryPointIcon: picIcon ? picIcon : 0,
					id: this.id,
					customerId: customid,
				});
				if (res.data === 'success') {
					this.success('已自动保存，发布后生效！');
				} else {
					this.fail('保存失败，请重新编辑！');
				}
				this.emitData();
				if (reset) {
					reset();
				}
			} catch (error) {
				this.emitData();
				if (reset) {
					reset();
				}
			}
		},

		// 欢迎语的保存修改
		async Saveconversation(conversation, menuList, youxiang, requireemailtxt, reset) {
			this.dialogue = conversation;
			this.menuList = menuList;
			this.emailOpenFlag = menuList[0].btnStatus;
			this.emailName = menuList[0].btnpanl[0].btnpanlContent;
			this.staffServiceOpenFlag = menuList[1].btnStatus;
			this.staffServiceName = menuList[1].btnpanl[0].btnpanlContent;
			this.staffServiceContent = menuList[1].btnpanl[1].btnpanlContent;
			this.visitWebsiteOpenFlag = menuList[2].btnStatus;
			this.visitWebsiteName = menuList[2].btnpanl[0].btnpanlContent;
			this.visitWebsiteContent = menuList[2].btnpanl[1].btnpanlContent;
			this.email = youxiang;
			this.emailContent = requireemailtxt;
			try {
				let res = await chat.getfabasic({
					serviceSiteId: this.getserviceId,
					dialogueGreetings: conversation,
					emailOpenFlag: menuList[0].btnStatus,
					emailName: menuList[0].btnpanl[0].btnpanlContent,
					staffServiceOpenFlag: menuList[1].btnStatus,
					staffServiceName: menuList[1].btnpanl[0].btnpanlContent,
					staffServiceContent: menuList[1].btnpanl[1].btnpanlContent,
					visitWebsiteOpenFlag: menuList[2].btnStatus,
					visitWebsiteName: menuList[2].btnpanl[0].btnpanlContent,
					visitWebsiteContent: menuList[2].btnpanl[1].btnpanlContent,
					requestEmail: youxiang,
					emailContent: requireemailtxt,
					id: this.id,
					customerId: this.getcustomerId,
				});
				if (res.data === 'success') {
					this.success('已自动保存，发布后生效');
				} else {
					this.fail('保存失败，请重新编辑');
				}
				this.emitData();
				reset();
			} catch (error) {
				this.emitData();
				reset();
			}
		},
		//固定菜单的保存修改
		async SaveFixmenu(menuFlag, problemlist, reset) {
			this.bottomFlag = menuFlag;
			this.fbConfigProblemDTOList = problemlist;
			try {
				let res = await chat.getfabasic({
					serviceSiteId: this.getserviceId,
					customerId: this.getcustomerId,
					bottomFlag: menuFlag,
					fbConfigProblemDTOList: problemlist,
					id: this.id,
				});
				if (res.data === 'success') {
					this.success('已自动保存，发布后生效');
				} else {
					this.fail('保存失败，请重新编辑');
				}
				this.emitData();
				reset();
			} catch (error) {
				this.emitData();
				reset();
			}
		},
		// 提交数据
		emitData() {
			let data = {
				serviceSiteId: this.getserviceId,
				customerId: this.getcustomerId,
				colour: this.color,
				showPosition: this.position,
				visitorFlag: this.pattern,
				pageGreetings: this.page,
				loginGreetings: this.login,
				visitorGreetings: this.visitor,
				dialogueGreetings: this.dialogue,
				emailOpenFlag: this.emailOpenFlag,
				emailName: this.emailName,
				staffServiceOpenFlag: this.staffServiceOpenFlag,
				staffServiceName: this.staffServiceName,
				staffServiceContent: this.staffServiceContent,
				visitWebsiteOpenFlag: this.visitWebsiteOpenFlag,
				visitWebsiteName: this.visitWebsiteName,
				visitWebsiteContent: this.visitWebsiteContent,
				requestEmail: this.email,
				emailContent: this.emailContent,
				bottomFlag: this.bottomFlag,
				greetingDialogDisplay: this.DialogDisplay,
				entryPointIcon: this.pointIcon,
				entryPointLabel: this.pointLabel,
				fbConfigProblemDTOList: this.fbConfigProblemDTOList,
				id: this.id,
			};
			this.$emit('emitData', data);
		},
		success: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'success',
			});
		},
		fail: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'error',
			});
		},
	},
	computed: {
		queryParam() {
			return this.$route.query;
		},
		getserviceId: function () {
			let serviceId = this.$route.query.serviceSiteId;
			return serviceId;
		},

		getId: function () {
			let Id = this.$route.query.id;
			return Id;
		},

		getcustomerId: function () {
			let customerId = this.$route.query.customerId;
			return customerId;
		},

		gettpageId: function () {
			let tpageId = this.$route.query.tpageId;
			return tpageId;
		},
	},
};
</script>

<style lang="scss" scoped>
.autoReplyConfig {
	.config {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		margin: 20px 0;
	}

	.hint {
		margin-left: 10px;
		color: #999;
		font-size: 12px;
		font-weight: normal;
	}
}
</style>
